import styled from 'styled-components';
import RichText from 'components/RichText';
import BREAKPOINTS from 'styles/breakpoints';
import TYPO from 'styles/typography';

import Button from 'components/Button';

const Container = styled.div`
  padding: 80px var(--gutter-side);

  ${BREAKPOINTS.medium`
    --gutter: 40px;
    padding-top: 100px;
    padding-bottom: 120px;
  `}
`;

const H3 = styled(RichText)`
  ${TYPO.h3}
  margin-bottom: 30px;
  text-align: left;

  ${BREAKPOINTS.medium`
    text-align: center;
    margin-bottom: 50px;
  `}
`;

const RichTextStyled = styled(RichText)`
  max-width: 670px;
  margin: auto;
  text-align: left;

  ${BREAKPOINTS.medium`
    text-align: center;
  `}
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 40px;
`;

const ImageSliderSubSection = ({ subHeading, subCopy, showRegisterCta }) => {
  return (
    <Container>
      <H3 html={subHeading} small />
      <RichTextStyled html={subCopy?.html} textIndent />

      {showRegisterCta && (
        <ButtonContainer>
          <Button target="_self" href="#register-interest">
            Register interest
          </Button>
        </ButtonContainer>
      )}
    </Container>
  );
};

export default ImageSliderSubSection;
